export default function ImageCollage () {
  const COLLAGES = document.querySelectorAll('.mtt-image-collage')

  if (COLLAGES.length) {
    for (let i = 0; i < COLLAGES.length; i++) {
      const COLLAGE = COLLAGES[i]
      const HOVER_FUNCTIONALITY = new HoverState(COLLAGE)
      HOVER_FUNCTIONALITY.init()
    }
  }
}

class HoverState {
  constructor (collage) {
    this.collage = collage
    this.images = collage.querySelectorAll('.mtt-image-collage__image-wrapper')

    this.init = () => {
      this.addHover()
    }

  }

  addHover () {
    if (this.images.length)
      for (let i = 0; i < this.images.length; i++) {
        const image = this.images[i]

        image.addEventListener('mouseenter', () => {
          if (window.innerWidth > 1160) {
            this.toggleAnimation()
          }
        }, false)

        image.addEventListener('mouseleave', () => {
          if (window.innerWidth > 1160) {
            this.toggleAnimation()
          }
        }, false)
      }
  }

  toggleAnimation () {
    const ANIMATION_DIV = this.collage.querySelectorAll('.mtt-image-collage__wrapper')

    if (ANIMATION_DIV.length) {
      for (let i = 0; i < ANIMATION_DIV.length; i++) {
        const ELEMENT = ANIMATION_DIV[i]

        if (!ELEMENT.classList.contains('paused')) {
          ELEMENT.classList.add('paused')
        } else {
          ELEMENT.classList.remove('paused')
        }
      }
    }
  }
}